import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lightning } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";

export default function MemberLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [helpMsg, setHelpMsg] = useState(null);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setHelpMsg(null);
    try {
      const { data } = await api.post("/member/login", { email, password });
      localStorage.setItem("vb_member_token", data.token);
      localStorage.setItem("vb_member", JSON.stringify(data.member));
      toast.success(`Olá, ${data.member.name}`);
      nav("/member");
    } catch (err) {
      const msg = errMsg(err, "Credenciais inválidas");
      toast.error(msg);
      // Guia adicional se der credenciais inválidas
      setHelpMsg({
        title: "Não consegue entrar?",
        items: [
          "Você já concluiu o cadastro na tela pós-pagamento (informando sua senha)?",
          "A senha é aquela que VOCÊ definiu na tela de acesso, não a de nenhum e-mail.",
          "Verifique se digitou o mesmo e-mail usado na compra.",
          "Se acabou de pagar mas ainda não completou cadastro, volte ao link do funil e clique '✅ Já paguei · verificar agora'.",
        ],
      });
    } finally { setLoading(false); }
  };

  const inp = "w-full bg-[var(--bg-base)] border border-[var(--border)] rounded-sm px-4 py-3 focus:border-[var(--accent)] outline-none";
  return (
    <div className="min-h-screen flex items-center justify-center px-6 hero-grid-bg">
      <div className="w-full max-w-md card-flat p-10 fadeUp">
        <Link to="/" className="flex items-center gap-2 mb-8" data-testid="member-brand">
          <Lightning size={26} weight="fill" color="var(--accent)" />
          <span className="font-display font-black text-xl tracking-tight">MERCADOPAGU · Área do aluno</span>
        </Link>
        <div className="label-caps mb-2">Área de membro</div>
        <h1 className="font-display font-black text-3xl tracking-tight mb-2">Acessar meus cursos</h1>
        <p className="text-white/50 text-sm mb-6">Use o e-mail e a senha que você definiu na compra. A senha aparece na tela de acesso após pagamento — nunca enviamos por e-mail.</p>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="label-caps block mb-2">E-mail</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="member-email" className={inp} /></div>
          <div><label className="label-caps block mb-2">Senha</label><input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="member-password" className={inp} /></div>
          <button disabled={loading} data-testid="member-login-submit" className="btn-primary w-full">{loading ? "Entrando..." : "Entrar"}</button>
        </form>
        {helpMsg && (
          <div className="mt-6 border border-amber-500/30 bg-amber-500/5 rounded-sm p-4 text-xs" data-testid="member-login-help">
            <div className="font-bold text-amber-300 mb-2">{helpMsg.title}</div>
            <ul className="space-y-1.5 text-white/70 list-disc pl-4">
              {helpMsg.items.map((it, i) => <li key={i}>{it}</li>)}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
